import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { getCategories } from '@/domain/external-invitation/utils/category/get-categories';
import { StakeholderItem } from '@/ui/pages/app/components/stakeholders/ModalStakeholders';

type InvitationsPerSector = {
  SITE: ExternalInvitation[];
  TEAM: ExternalInvitation[];
  PUBLIC: ExternalInvitation[];
};

export function prepareModalStakeholdersItems(
  invitationsPerSector: InvitationsPerSector,
): StakeholderItem[] {
  return [
    {
      sector: 'SITE',
      existingInvitations: invitationsPerSector['SITE'],
      categories: getCategories('venue-structure', 'SITE'),
    },
    {
      sector: 'TEAM',
      existingInvitations: invitationsPerSector['TEAM'],
      categories: getCategories('venue-structure', 'TEAM'),
    },
    {
      sector: 'PUBLIC',
      existingInvitations: invitationsPerSector['PUBLIC'],
      categories: getCategories('venue-structure', 'PUBLIC'),
    },
  ];
}
